import React, { useEffect, useState } from "react";
import { Phone, ArrowRight } from "@phosphor-icons/react";
import { COMPANY } from "@/lib/site-data";

/**
 * Sticky bottom CTA bar visible on mobile only.
 * Appears after the user scrolls past the hero — a constant, low-friction
 * conversion path: tap to call OR tap to quote.
 */
export default function MobileStickyBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-bar"
      aria-hidden={!show}
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-slate-900 border-t-2 border-sky-500 grid grid-cols-2 divide-x-2 divide-sky-500/40">
        <a
          href={`tel:${COMPANY.phoneRaw}`}
          data-testid="mobile-sticky-call"
          className="flex items-center justify-center gap-2 py-4 text-white font-bold text-sm uppercase tracking-[0.14em] active:bg-slate-800"
        >
          <Phone size={18} weight="bold" />
          Call now
        </a>
        <a
          href="/book"
          data-testid="mobile-sticky-quote"
          className="flex items-center justify-center gap-2 py-4 bg-sky-500 text-white font-bold text-sm uppercase tracking-[0.14em] active:bg-sky-600"
        >
          Book Now
          <ArrowRight size={18} weight="bold" />
        </a>
      </div>
    </div>
  );
}
